import Image from "next/image";
import Link from "next/link";
import logo from "../../../../../public/images/logo_platform.png";
import logoMobile from "../../../../../public/images/logo_platform.png";

export default function Logo() {
    return (
        <Link href="/" className="block px-2 py-3">
            <Image src={logo} alt="Logo" height={40} className="hidden md:block" priority />
            <Image src={logoMobile} alt="Logo" height={38} className="block md:hidden" priority />
        </Link>
    );
}
